var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"micro-dashboard"}},[_c('h1',[_vm._v("Global Number = "+_vm._s(_vm.globalNumber))]),_vm._l((_vm.vueApps),function(v){return _c('div',{key:v.name,staticClass:"list-item"},[_c('VueContainer',{attrs:{"vueApp":v}})],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }